export default {
  MENU_CLICK: 'menu_click',
  MENU_READY: 'menu_ready',
  GETWAY_SAVE: 'getway_save',
}
